import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx';
import { FunctionComponent, useMemo } from 'react';
import Filter from 'components/Bookings2/List/Filter/Filter';
import { DEMO_LOCATIONS } from '../data/mockData';
import styles from './LocationFilter.module.scss';

/*
 * Demo-only location filter: it always offers the mocked demo locations so
 * the multi-location story renders identically on single-location accounts,
 * where OrganizationMarketplacesFilter would hide itself.
 */
interface LocationFilterProps {
    selected: Array<number>;
    className?: string;
    onChangeSelection: (selectedLocationIds: Array<number>) => void;
}

export const LocationFilter: FunctionComponent<LocationFilterProps> = props => {
    const options = useMemo(() => DEMO_LOCATIONS.map(location => ({ id: location.id, name: location.name })), []);

    return (
        <Filter
            allLabel="All Locations"
            quantityLabel="locations"
            icon={faLocationDot}
            options={options}
            selectedOptions={options.filter(option => props.selected.includes(option.id))}
            onChangeSelection={selected => props.onChangeSelection(selected.map(option => option.id))}
            className={clsx(styles.root, props.className)}
        />
    );
};

export default LocationFilter;
